import { combineEpics } from 'redux-observable';
import { deleteNotificationSettingEpicReducer } from '../ducks/DeleteNotificationSetting.ducks';
import { loadNotificationSettingListEpicReducer } from '../ducks/LoadNotificationSettingList.ducks';
import { putNotificationSettingEpicReducer } from '../ducks/PutNotificationSetting.ducks';
export const rootEpic = combineEpics(loadNotificationSettingListEpicReducer.epic, putNotificationSettingEpicReducer.epic, deleteNotificationSettingEpicReducer.epic);
export default rootEpic;

//# sourceMappingURL=epics.js.map
